import useDispensary from 'dispensary/hooks/use-dispensary';

export function usePriceCartCalcs(): boolean {
  const { dispensary } = useDispensary();

  const discountSyncEnabled = dispensary?.storeSettings?.enableLLxSaleDiscountSync;

  return discountSyncEnabled;
}
